import { NavLink, Outlet } from "react-router-dom";
import "../../assets/css/devadmin.css";

const DevadminLayout = () => {
    return (
        <div className="mjsdev-container">
            <div className="mjsdev-container-left">
                <ul>
                    <li>
                        <NavLink to="dashboard" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-solid fa-house mjs_text_grey"></i> Dashboard
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="websites" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-regular fa-window-restore mjs_text_grey"></i> Websites
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="cold-emails" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-solid fa-envelope mjs_text_grey"></i> Cold Emails
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="users" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-solid fa-user mjs_text_grey"></i> Users
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="subscriptions" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-solid fa-store mjs_text_grey"></i> Subscriptions
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="payments" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-solid fa-sack-dollar mjs_text_grey"></i> Payments
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="support-tickets" className={({ isActive }) => isActive ? "dvactive" : ""}>
                            <i className="fa-solid fa-ticket mjs_text_grey"></i> Support Tickets
                        </NavLink>
                    </li>
                </ul>
            </div>

            <div className="mjsdev-container-right">
                <Outlet />
            </div>
        </div>
    );
};

export default DevadminLayout;
